import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import theme from "src/styles/theme";
import caseImage from "url:src/assets/images/case.png";

export default function CaseSection() {
  const cases = [
    {
      title: "杉並区の投資用不動産",
      image: caseImage,
      aiPrice: "2,760",
      offerPrice: "2,880",
      difference: "120",
    },
    {
      title: "世田谷区の投資用不動産",
      image: caseImage,
      aiPrice: "3,040",
      offerPrice: "3,120",
      difference: "80",
    },
    {
      title: "港区の投資用不動産",
      image: caseImage,
      aiPrice: "1,940",
      offerPrice: "1,990",
      difference: "50",
    },
  ];

  return (
    <Stack spacing={3} alignItems="center">
      <Typography>多くのオーナー様が、Propallyを通じて納得の価格で売却に成功しています。</Typography>

      <Box
        sx={{
          width: "100%",
          overflowX: "auto",
          scrollSnapType: "x mandatory",
        }}
      >
        <Stack direction="row" spacing={4} sx={{ width: "fit-content", padding: "40px 16px 0" }}>
          {cases.map((caseData, index) => (
            <CaseCard
              key={index}
              title={caseData.title}
              image={caseData.image}
              aiPrice={caseData.aiPrice}
              offerPrice={caseData.offerPrice}
              difference={caseData.difference}
            />
          ))}
        </Stack>
      </Box>
    </Stack>
  );
}

type CaseCardProps = {
  title: string;
  image: string;
  aiPrice: string;
  offerPrice: string;
  difference: string;
};

function CaseCard({ title, image, aiPrice, offerPrice, difference }: CaseCardProps) {
  return (
    <Box
      sx={{
        width: "300px",
        position: "relative",
        overflow: "visible",
        flexShrink: 0,
        scrollSnapAlign: "center",
      }}
    >
      <Box sx={{ overflow: "visible", position: "relative" }}>
        <Box
          component="img"
          src={image}
          alt={title}
          sx={{
            width: "100%",
            height: "140px",
            objectFit: "cover",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: "-20px",
            right: "-20px",
            background: theme.palette.secondary.gradient,
            color: "white",
            fontWeight: "bold",
            borderRadius: "50%",
            width: "70px",
            height: "70px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1,
          }}
        >
          +{difference}万
        </Box>
      </Box>

      <Box py={2}>
        <Typography fontWeight="bold">{title}</Typography>
      </Box>
      <Stack direction="row" spacing={1} alignItems="center">
        <Box
          sx={{
            flex: 1,
            textAlign: "center",
          }}
        >
          <Box sx={{ border: "1px solid #D5DAE4", borderRadius: "4px" }}>
            <Box sx={{ background: "#D5DAE4", padding: "8px 0" }}>
              <Typography>AI査定価格</Typography>
            </Box>
            <Box py={1}>
              <Typography>{aiPrice}万</Typography>
            </Box>
          </Box>
        </Box>

        <Typography variant="caption" color="primary.dark">
          ▶ ▶ ▶
        </Typography>

        <Box
          sx={{
            flex: 1,
            borderRadius: "4px",
            textAlign: "center",
          }}
        >
          <Box sx={{ border: `1px solid ${theme.palette.primary.dark}`, borderRadius: "4px" }}>
            <Box sx={{ backgroundColor: "primary.dark", padding: "8px 0" }}>
              <Typography color="white">査定オファー</Typography>
            </Box>
            <Box py={1}>
              <Typography fontSize="20px" lineHeight="24px" fontWeight="bold">
                {offerPrice}万
              </Typography>
            </Box>
          </Box>
        </Box>
      </Stack>
    </Box>
  );
}
